'use client'

import AccessController from '@/app/itineraries/(map-layout)/components/AccessController';
import NextLink from '@/components/NextLink';
import CalendarColor from '@/components/illustratores/CalendarColor';
import Button from '@/components/ui/Button';
import { useItineraryMapStore } from '@/core/stores/itinerary';
import { useItineraryStoreV2 } from '@/core/stores/itinerary/itineraryV2';
import { useItinerarySettingsStore } from '@/core/stores/itinerary/settings';
import { formatDate } from '@/utils/dateOperators/formatDate';
import { faGear } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Image from 'next/image';
import { ReactNode } from 'react';
import ParticipantImage from '../components/ParticipantImage';
import Tabs from './Tabs';
import TopSights from './TopSights';

export default function Layout({ children, params: { day } }: { children: ReactNode, params: { day: string } }) {

    const NEXT_PUBLIC_STORAGE_URL = process.env.NEXT_PUBLIC_STORAGE_URL

    // const { result: { city, days, startedAt, endedAt, settings, title } } = await Itinerary.getByIdV1(id);
    const { setSuggestionActivities, suggestionActivities } = useItineraryMapStore()
    const { itinerary, } = useItineraryStoreV2()
    const { setShowSettingsModal, setShowShareModal } = useItinerarySettingsStore()

    if (!itinerary) {
        return null
    }
    if (suggestionActivities.length > 0) {
        setSuggestionActivities([])
    }

    const id = itinerary?.id
    const city = itinerary?.city
    const days = itinerary?.days
    const startedAt = itinerary?.startedAt
    const endedAt = itinerary?.endedAt
    const title = itinerary?.title
    const users = itinerary.user

    return (
        <div className={`flex h-full w-full grow flex-col bg-white min-h-fit pb-16 md:pb-8`}>
            <div className="relative aspect-[2/1] w-full">

                <div className='flex z-30 items-center w-full justify-between md:justify-end absolute px-4 top-3'>

                    <NextLink href={'/'} className='size-6 md:hidden rounded-lg pr-1 cursor-pointer bg-black/50 flex justify-center items-center text-white'>
                        <svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.53809 1.63965L1.53809 7.63965L7.53809 13.6396" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </NextLink>

                    <div className='flex items-center gap-4'>
                        <AccessController allowedRoles={['owner', 'editor']} >
                            <Button onClick={() => setShowShareModal(true)} color='secondary' size='small' radius='rounded-xl' className='min-w-28'>
                                Share Itinerary
                            </Button>
                        </AccessController>

                        <AccessController allowedRoles={['owner', 'editor']} >
                            <FontAwesomeIcon onClick={() => setShowSettingsModal(true)}
                                icon={faGear} size="2xl"
                                className="size-6 block md:hidden rounded-xl p-1 text-white bg-black/50 h-5"
                            />
                        </AccessController>
                    </div>

                </div>


                <div className="absolute z-20 flex h-full w-full flex-col justify-end gap-2 
                                bg-gradient-to-t from-black to-gray-700/0 p-4 text-white"
                >

                    <p className='font-medium text-lg'>{city} Itinerary</p>
                    <p className=" font-bold mb-3 text-[28px]">
                        {title}
                    </p>

                    <div className='flex items-center justify-between'>
                        {startedAt && endedAt ? <div className='flex gap-2 items-center text-sm font-normal'>

                            <CalendarColor className='w-5' />
                            {formatDate(startedAt)}
                            <span> to </span>
                            {formatDate(endedAt)}
                        </div> : <span></span>}
                        <div className='flex items-center'>
                            {users.slice(0, 3).map((item, index) =>
                                <div
                                    key={item.id}
                                    style={{
                                        zIndex: users.length - index,
                                        translate: `-${10 * index}px`
                                    }} className='relative'>
                                    {item.userId ? <ParticipantImage

                                        size='24px'
                                        userId={item.userId} image={item.image} /> :
                                        <Image
                                            className='rounded-full aspect-square size-7'
                                            width={48}
                                            height={48}
                                            alt='Planzo'
                                            src={process.env.NEXT_PUBLIC_STORAGE_URL + 'assets/83cba617-bd82-4da1-b664-c5211694f815-planingo.png'} />
                                    }
                                </div>
                            )}
                            {users.length > 3 && <div style={{
                                zIndex: users.length + 1,
                                translate: `-${10 * 3}px`
                            }} className='relative flex items-center text-[10px] justify-center size-6 rounded-full bg-gray-600 text-white'>
                                + {users.length - 3}
                            </div>}
                        </div>
                    </div>
                </div>
                <Image
                    src={NEXT_PUBLIC_STORAGE_URL + 'assets/b5631fb2-cff2-40db-9ce4-a210c79b2f9f.png'}
                    width={500}
                    className='h-72'
                    height={400}
                    alt='itinerary' />
            </div>
            <Tabs itineraryId={id} days={days} />

            <div className='w-full bg-white px-4 py-4  text-gray-800'>
                {children}
            </div>
            <div className=' '>

                <TopSights />
            </div>
        </div >
    )
}
